import { defineComponent as d, computed as o, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "03ccc28a-e929-4825-be48-6d7b3a4b2dae" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#03ccc28a-e929-4825-be48-6d7b3a4b2dae)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#6da544" d="M77.7 0H512v512H77.8z"></path><path fill="#eee" d="M425.4 254.7 31.4 512h46.4L512 256 77.7 0H31.4z"></path><path fill="#ffda44" d="M256 256 31.4 512l436.8-256L31.4 0z"></path><path fill="#333" d="M0 0v1.8l219.6 253.8L0 510v2h31.4l256-256L31.4 0z"></path><path fill="#d80027" d="M0 0v512l256-256L0 0z"></path>', 5), g = { fill: "none" }, x = ["r"], b = /* @__PURE__ */ d({
  __name: "gy",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), c("title", k, n(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  b as default
};
//# sourceMappingURL=gy-3fee4ec1.js.map
